/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './sw-management.scss';

/* eslint-disable import/no-unresolved, import/default */

import swManagementTemplate from './sw-management.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.swManagement', [])
    .directive('tkSwManagement', SwManagement)
    .name;

/*@ngInject*/
function SwManagement() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            gatewayId: '=',
            isReadOnly: '='
        },
        controller: SwManagementController,
        controllerAs: 'vm',
        templateUrl: swManagementTemplate
    };
}

/*@ngInject*/
function SwManagementController($rootScope, $scope, $element, gatewayCommandService, $filter, $translate, $mdMedia, types, toast, $timeout, $q) {

    var vm = this;

    vm.$onInit = function () {
        vm.types = types;

        vm.allComponents = [];
        vm.components = [];
        vm.selectedComponents = [];
        vm.rowsCount = 0;

        vm.verType = types.software.verType.short.value;
        vm.mode = types.software.mode.swList;

        vm.hasBspUpgrade = false;
        vm.installUpgradeStatusMessage = null;
        vm.bspUpgradeInProgress = 0;

        vm.query = {
            order: 'index',
            limit: 15,
            page: 1,
            search: null
        };

        vm.limitOptions =
            [15, 30, 45];

        vm.onReorder = function () {
            updateComponents();
        };

        vm.onPaginate = function () {
            updateComponents();
        };

        vm.enterFilterMode = function () {
            vm.query.search = '';
        };

        vm.exitFilterMode = function () {
            vm.query.search = null;
            updateComponents();
        };

        vm.readSoftwareVersions = readSoftwareVersions;
        vm.getBspStatus = getBspStatus;
        vm.readUpgradable = readUpgradable;
        vm.readInstallable = readInstallable;
        vm.noDataPrompt = noDataPrompt;
        vm.installAll = installAll;
        vm.installSelected = installSelected;
        vm.upgradeBsp = upgradeBsp;
        vm.getLastUpgradeInstallStatus = getLastUpgradeInstallStatus;


        vm.loading = function () {
            return $rootScope.loading;
        };
    };

    $scope.$watch('vm.gatewayId', (newVal) => {
        if (newVal) {
            reload();
        }
    });

    $scope.$watch(function () {
        return $mdMedia('gt-md');
    }, function (isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [15, 30, 45];
        } else {
            vm.limitOptions = null;
        }
    });

    $scope.$watch("vm.query.search", function (newVal, prevVal) {
        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
            updateComponents();
        }
    });

    function reload() {
        toast.hide();
        vm.mode = types.software.mode.swList;
        vm.verType = types.software.verType.short.value;
        vm.allComponents.length = 0;
        vm.components.length = 0;
        vm.rowsCount = 0;
        vm.selectedComponents.length = 0;
        vm.hasBspUpgrade = false;
        vm.installUpgradeStatusMessage = null;
        vm.bspUpgradeInProgress = 0;
    }

    function readSoftwareVersions() {
        toast.hide();
        vm.allComponents.length = 0;
        vm.components.length = 0;
        vm.rowsCount = 0;
        vm.swComponentsPromise = gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.softwareCommand.getSoftwareVersions.value, {verType: types.software.verType[vm.verType].id});
        vm.swComponentsPromise.then(
            (components) => {
                vm.mode = types.software.mode.swList;
                vm.query.search = null;
                vm.selectedComponents.length = 0;
                vm.allComponents = components;
                updateComponents();
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }

    function getBspStatus() {
        toast.hide();
        vm.swComponentsPromise = gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.softwareCommand.getBspStatus.value, {});
        vm.swComponentsPromise.then(
            (bspStatus) => {
                var bspStatusType = types.software.bspStatus[bspStatus];
                var bspStatusMessage;
                if (angular.isDefined(bspStatusType)) {
                    bspStatusMessage = $translate.instant(bspStatusType.name);
                } else {
                    bspStatusMessage = $translate.instant('software.bsp-status-unknown', {bspStatus: bspStatus});
                }
                toast.showInfo(bspStatusMessage, null, $element.closest(".toast-parent"), 'bottom left');
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }

    function readUpgradable(hideSpecialPackagesToast) {
        toast.hide();
        vm.installUpgradeStatusMessage = null;
        vm.allComponents.length = 0;
        vm.components.length = 0;
        vm.rowsCount = 0;
        vm.swComponentsPromise = gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.softwareCommand.getUpgradableSoftware.value, {});
        vm.swComponentsPromise.then(
            (components) => {
                vm.mode = types.software.mode.upgradableList;
                vm.query.search = null;
                vm.selectedComponents.length = 0;
                vm.allComponents = components;
                updateComponents(hideSpecialPackagesToast);
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }

    function readInstallable(hideSpecialPackagesToast, ) {
        toast.hide();
        vm.installUpgradeStatusMessage = null;
        vm.allComponents.length = 0;
        vm.components.length = 0;
        vm.rowsCount = 0;
        vm.swComponentsPromise = gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.softwareCommand.getInstallableSoftware.value, {});
        vm.swComponentsPromise.then(
            (components) => {
                vm.mode = types.software.mode.installableList;
                vm.query.search = null;
                vm.selectedComponents.length = 0;
                vm.allComponents = components;
                updateComponents(hideSpecialPackagesToast);
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }

    function installAll() {
        performInstall('all');
    }

    function installSelected() {
        if (vm.selectedComponents.length) {
            var packageList = [];
            for (var i=0;i<vm.selectedComponents.length;i++) {
                packageList.push(vm.selectedComponents[i].name);
            }
            performInstall(packageList.join(' '));
        }
    }

    function upgradeBsp() {
        var result = $filter('filter')(vm.allComponents, {special: 2});
        if (result && result.length) {
            vm.bspUpgradeInProgress = 120;
            performInstall(result[0].name, $translate.instant('software.bsp-status-bsp-upgrade-busy'), true);
        }
    }

    function getLastUpgradeInstallStatus() {
        toast.hide();
        var deferred = $q.defer();
        vm.swComponentsPromise = gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.softwareCommand.getLastInstallUpgradeStatus.value, {});
        vm.swComponentsPromise.then(
            (response) => {
                var statusDescription;
                var statusResponse;
                if (response) {
                    var statusType = response.lastOperation;
                    var statusTypeMessage;

                    if (statusType === 'install') {
                        statusTypeMessage = types.software.installStatus[response.lastStatus];
                    } else {
                        statusTypeMessage = types.software.upgradeStatus[response.lastStatus];
                    }

                    if (angular.isDefined(statusTypeMessage)) {
                        statusDescription = $translate.instant(statusTypeMessage.name);
                    } else {
                        statusDescription = $translate.instant('software.upgrade-status-unknown', {upgradeStatus: response});
                    }

                    statusResponse  = response.lastStatus;
                } else {
                    statusDescription = $translate.instant('software.upgrade-status-unknown', {upgradeStatus: response});
                }

                deferred.resolve({
                    msg: statusDescription,
                    statusCode: statusResponse
                });
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function performInstall(packages, msg, isBspUpgrade) {
        toast.hide();
        var command;
        var params = {};
        vm.selectedComponents.length = 0;
        updateInstallUpgradeMessage(msg);
        if (vm.mode == types.software.mode.upgradableList) {
            command = types.softwareCommand.upgradeSoftware.value;
            params.packageToUpgrade = packages;
        } else {
            command = types.softwareCommand.installSoftware.value;
            params.packageToInstall = packages;
        }
        vm.swComponentsPromise = gatewayCommandService.executeCommand(vm.gatewayId.id,
            command, params);

        $timeout(() => {
            vm.swComponentsPromise.then(
                () => {
                    if (vm.mode == types.software.mode.upgradableList) {
                        readUpgradable(true);
                    } else {
                        readInstallable(true);
                    }
                    startInstallUpgradeStatusPooling(msg, isBspUpgrade);
                },
                (rejection) => {
                    toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
                }
            );
        }, 2500);


    }

    function startInstallUpgradeStatusPooling(msg, isBspUpgrade) {
        updateInstallUpgradeMessage(msg);
        poolInstallUpgradeStatus(1000, isBspUpgrade);
    }

    function poolInstallUpgradeStatus(poolInterval, isBspUpgrade) {
        $timeout(() => {
            var result;
            if (vm.mode === types.software.mode.upgradableList || vm.mode === types.software.mode.installableList) {
                result = getLastUpgradeInstallStatus();
            }
            else {
                return;
            }
            result.then((pooledResult) => {
                    if (angular.isUndefined(pooledResult.statusCode)) {
                        if (vm.bspUpgradeInProgress > 0) {
                            vm.bspUpgradeInProgress--;
                            updateInstallUpgradeMessage($translate.instant('software.bsp-status-bsp-upgrade-busy'));
                            poolInstallUpgradeStatus(poolInterval, isBspUpgrade);
                        } else {
                            if (isBspUpgrade) {
                                updateInstallUpgradeMessage($translate.instant('software.bsp-status-unknown', {bspStatus: $translate.instant('error.unknown-error')}))
                            } else {
                                updateInstallUpgradeMessage($translate.instant('error.unknown-error'));
                            }
                        }
                    } else if (pooledResult.statusCode === 90000 || pooledResult.statusCode === 90001) {
                        updateInstallUpgradeMessage(pooledResult.msg);
                        poolInstallUpgradeStatus(poolInterval, isBspUpgrade);
                    } else {
                        if (isBspUpgrade) {
                            if (pooledResult.statusCode === 0) {
                                gatewayCommandService.executeCommand(vm.gatewayId.id,
                                    types.softwareCommand.getBspStatus.value, {}).then(
                                    (bspStatus) => {

                                        var bspStatusType = types.software.bspStatus[bspStatus];

                                        if (bspStatus === 90000 || bspStatus === 90001) {
                                            poolInstallUpgradeStatus(poolInterval, isBspUpgrade);
                                        } else {
                                            updateInstallUpgradeMessage($translate.instant(bspStatusType.name));
                                        }
                                    },
                                    (rejection) => {
                                        updateInstallUpgradeMessage(rejection.data);
                                    }
                                );
                            } else {
                                var bspStatusType = types.software.bspStatus[pooledResult.statusCode];
                                updateInstallUpgradeMessage($translate.instant(bspStatusType.name));
                            }
                        } else {
                            updateInstallUpgradeMessage(pooledResult.msg);
                        }
                    }
                },
                (rejection) => {
                    if (vm.bspUpgradeInProgress > 0) {
                        vm.bspUpgradeInProgress--;
                        updateInstallUpgradeMessage($translate.instant('software.bsp-status-bsp-upgrade-busy'));
                        poolInstallUpgradeStatus(poolInterval, isBspUpgrade);
                    } else {
                        vm.installUpgradeStatusMessage = null;
                        vm.bspUpgradeInProgress = 0;
                        toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
                    }

                });

        }, poolInterval);
    }

    function updateInstallUpgradeMessage(message) {
        if (vm.mode == types.software.mode.upgradableList) {
            vm.installUpgradeStatusMessage = $translate.instant('software.upgrade-status', {upgradeStatus: message});
        } else {
            vm.installUpgradeStatusMessage = $translate.instant('software.install-status', {installStatus: message});
        }
    }

    function noDataPrompt() {
        var message;
        if (vm.query.search != null) {
            message = 'software.no-components-prompt';
        } else {
            message = vm.mode.noDataPrompt;
        }
        return $translate.instant(message);
    }

    function updateComponents(hideSpecialPackagesToast) {
        var result;
        if (vm.query.order.endsWith('index')) {
            var reverse = vm.query.order.startsWith('-');
            result = $filter('orderBy')(vm.allComponents, (component) => {
                return component;
            }, reverse,  (component1, component2) => {
                var index1 = vm.allComponents.indexOf(component1.value);
                var index2 = vm.allComponents.indexOf(component2.value);
                var res = index1 - index2;
                return res > 0 ? 1 : (res < 0 ? -1 : 0);
            });
        } else {
            result = $filter('orderBy')(vm.allComponents, vm.query.order);
        }
        vm.hasBspUpgrade = false;
        vm.allComponents.forEach(component => {
            if (component.special) {
                if (!hideSpecialPackagesToast) {
                    toast.showInfo($translate.instant('software.special-packages-prompt'), null, $element.closest(".toast-parent"), 'bottom left');
                }
                if (component.special == 2) {
                    vm.hasBspUpgrade = true;
                }
            }
        });
        if (vm.query.search != null) {
            result = $filter('filter')(result, {$: vm.query.search});
        }
        vm.rowsCount = result.length;
        var startIndex = vm.query.limit * (vm.query.page - 1);
        vm.components = result.slice(startIndex, startIndex + vm.query.limit);
    }

}



// WEBPACK FOOTER //
// ./src/app/gateway/software/sw-management.directive.js